import { memo, useState } from "react";
import { useSelector } from "react-redux";
import { AsyncPaginate } from "react-select-async-paginate";
import { ForeignData_API } from "../../APIs/ForeignData.api";

const Component = ({
  label,
  table_id,
  primary_key,
  onChange,
  displayFields,
}) => {
  const [data, setData] = useState({
    options: [],
    hasMore: false,
    additional: {
      page: 0,
    },
  });
  const [selectedValue, setSelectedValue] = useState();

  const { lang, proxy, auth, pages, functions } = useSelector((state) => state);
  const { filterData } = functions;
  const _token = localStorage.getItem("_token");

  const handleGetData = async (page = 0, search = "") => {
    return new Promise(async (resolve, reject) => {
      let dataBody = {
        table_id,
        start_index: page,
        type: "or",
      };
      if (search) {
        let criteria = {};
        let criteria_type = {};
        displayFields &&
          displayFields.forEach((field) => {
            criteria[field.value] = search.trim();
            criteria_type[field.value] = "regex";
          });

        dataBody.criteria = criteria;
        dataBody.criteria_type = criteria_type;
      }

      try {
        const { data, fields } = await ForeignData_API.get(
          proxy(),
          _token,
          dataBody
        );

        const alias = fields.find(
          (field) => field.id === primary_key
        )?.fomular_alias;

        let newData = {
          options: [],
          hasMore: false,
          additional: {
            page: 0,
          },
        };
        let hasMoreValue = true;

        if (!data?.length) {
          hasMoreValue = false;
        }
        if (data.length) {
          const mappedOpt = data.map((item) => {
            let label = "";
            if (displayFields && displayFields.length) {
              label = displayFields.map((field) => item[field.value]).join("|");
              return {
                label,
                value: item[alias],
              };
            }
            return {
              label: item[alias],
              value: item[alias],
            };
          });

          setData((prev) => {
            newData = {
              hasMore: hasMoreValue,
              options: mappedOpt,
              additional: {
                page: hasMoreValue ? page + 15 : page,
              },
            };

            return {
              hasMore: hasMoreValue,
              options: [...prev.options, ...mappedOpt],
              additional: {
                page: hasMoreValue ? page + 15 : page,
              },
            };
          });
        }
        setTimeout(() => {
          resolve(newData);
        }, 100);
      } catch (err) {
        console.log("OPTION ERROR:", err);
      }
    });
  };

  const handleOnchange = (props) => {
    setSelectedValue(props);
    onChange(props);
  };
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "5px",
      border: "2px solid #ccc",
      boxShadow: state.isFocused ? "0 0 0 2px #3699FF" : null,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#3699FF" : null,
      color: state.isFocused ? "white" : null,
    }),
  };
  return (
    <div style={{ width: "300px" }}>
      <AsyncPaginate
        loadOptions={async (search, loadedOptions, { page }) => {
          return await handleGetData(page, search);
        }}
        onChange={({ label, value }) => {
          // if (value === "") {
          //   handleOnchange({ label, value });
          //   // handleOnchange("");
          //   return;
          // }
          handleOnchange({ label, value });
        }}
        isSearchable={true}
        styles={{
          menuList: (base) => ({
            ...base,
            maxHeight: "300px",
            // color: "#58718a !important"
            fontFamily: "UTM Avo , sans-serif !important",
          }),
        }}
        placeholder={lang["select value"]}
        value={selectedValue}
        additional={{
          page: 0,
        }}
        noOptionsMessage={() => (
          <div style={{ fontWeight: "300" }}>{lang["not found data"]}</div>
        )}
        allowCreateWhileLoading={false} // Không cho phép tạo mới khi đang tải dữ liệu
      />
    </div>
  );
};
export const Option = memo(Component);
